<template>
    <div slot="breadcrumb" class="mb-4 d-flex align-items-center" id="breadcrumb">
        <router-link :to="{ name: 'AppointmentList' }">Appointment</router-link>
        <i class="dripicons-chevron-right mr-1 ml-1 pt-1"></i>
        <span class="active">{{ fullName }}</span>
    </div>
</template>

<script>
  export default {
    props: {
      patient: {
        type: Object
      }
    },

    computed: {
      fullName() {
        return (this.appointment)
          ? this.appointment.patient.last_name + ' ' + this.appointment.patient.first_name
          : null;
      }
    },

    data() {
      return {};
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Detail/AppointmentDetailBreadcrumb.vue